import React from "react";
import { Tabs, Button, Drawer, Menu, Dropdown, Icon } from "antd";
import "antd/dist/antd.css";
import "./main-content.styles.css";
import Logo from "../../assets/logo.jpg";
import Burger from "../../assets/Hamburger.svg";

import BuyingRecomandationContainer from "../../pages/buying-recomandation-container/buying-recomandation-container";
import BuyingDecisionContainer from "../../pages/buying-decision-container/buying-decision-container.page";
import Home from "../../pages/home/home.page";
import ArrivalsEntry from "../../pages/arrivals-entry/arrivals-entry.page";
import Summary from "../../pages/summary/summary.page";
import VarietalSubstitution from "../../pages/varietal-substitution/varietal-substitution.page";
import Report from "../../pages/report/report.page";
import ForecastTabs from "../buying-recommendation-tabs/buying-recommendation-tabs-component";
import AdminTabs from "../admin-tabs/admin-tabs.component";
import MasterTabs from "../master-screens/master-screens.component";
import CompetitionAnalysis from "../../pages/market-analysis/market-analysis.page";

import WeatherWidget from "../weather-widget/weather-widget.component";

import MenuItemGroup from "../menu-item-selector-group/menu-item-selector-group.component";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Link, withRouter, Switch, Route } from "react-router-dom";

import { collapseSidemenu } from "../../redux/side-menu/side-menu.actions";

import { setScreenName, setSummaryVisibility } from "../../redux/arrival-entry/arrival-entry.actions";
import { setCurrentArrivalScreen } from "../../redux/map/map.actions";
import {
  setUserLoggedStatus,
  setAccessToken,
  setRefreshToken,
} from "../../redux/user/user.actions";

import { selectUserData } from "../../redux/user/user.selectors";

import { canUserEdit } from "../../auth/utils";
import { FeatureCodes } from "../../auth/data";

import { Component } from "react";

import { SignOutAPI } from "../../auth/utils";
import API from "../../api";
import CitContainer from "../../pages/intelegence-tower-container/cit-container";
import { setScreen } from "../../redux/commodity-intelegence-tower/commodity-intelegence-tower.actions";
import BulkUploadScreen from "../../pages/bulk-upload/bulk-upload-screen.page";

const { TabPane } = Tabs;

/**
 *@component
 *@description Parent component of all tabs
 *@memberof App.MainLayout
 */
class MainContent extends Component {
  state = {
    currentTab: "1",
    selectedMenu: "1",
    menuVisible: false,
  };

  changeKeyOnlyOnSelectedTab = (tabkey) => {
    if (tabkey === this.state.currentTab) {
      return tabkey + 1;
    } else return tabkey;
  };

  handleLogoutButton = async () => {
    SignOutAPI();

    await localStorage.clear();
    this.props.setAccessToken(null);
    this.props.setRefreshToken(null);
    this.props.setUserLoggedStatus(false);
    this.props.setScreen(0);
    // this.props.history.push("/login");
  };
  renderContent = () => {
    switch (this.state.selectedMenu) {
      case "1":
        return <ArrivalsEntry key={this.state.currentTab} />;
      case "2":
        return <BulkUploadScreen key={1} />;
      default:
        return <ArrivalsEntry key={this.state.currentTab} />;
    }
  };
  handleMenuClick = ({ key }) => {
    this.setState({ selectedMenu: key });
    this.props.setScreenName(1)
  };

  renderTabs = () => {
    const menu = (
      <Menu onClick={this.handleMenuClick}>
        <Menu.Item key="1">Manual Entry</Menu.Item>
        <Menu.Item key="2">Bulk Upload</Menu.Item>
      </Menu>
    );
    if (
      canUserEdit(this.props.userData, null, FeatureCodes.ITC_CIT) ||
      canUserEdit(this.props.userData, null, FeatureCodes.ITC_CIT_VIEW)
    ) {
      return [
        <TabPane tab="CIT" key="10">
          <CitContainer key={this.state.currentTab} />
        </TabPane>,
      ];
    } else {
      return [
        <TabPane tab="Home" key="1">
          <Home />
        </TabPane>,
        process.env.REACT_APP_ENV !== "production" && (
          <TabPane tab="Buying Recommendation" key="2">
            <BuyingRecomandationContainer key={this.state.currentTab} />
          </TabPane>
        ),
        <TabPane
          // tab="Arrivals"
          tab={
            <span>
              <Dropdown overlay={menu} trigger={["hover"]}>
                <span onClick={(e) => e.preventDefault()}>
                  Arrivals <Icon type="down" />
                </span>
              </Dropdown>
            </span>
          }
          key="3"
        >
          {/* <ArrivalsEntry key={this.state.currentTab} /> */}
          {this.renderContent()}
        </TabPane>,
        <TabPane tab="Market Snapshot" key="4">
          <CompetitionAnalysis />
        </TabPane>,
        <TabPane tab="Buying Decision" key="5">
          <BuyingDecisionContainer key={this.state.currentTab} />
        </TabPane>,
        <TabPane tab="Arrival Summary" key="6">
          <Summary isTab key={this.state.currentTab} />
        </TabPane>,
        canUserEdit(
          this.props.userData,
          null,
          FeatureCodes.REPORTS_PURCHASE_EFFICIENCY,
        ) ||
        canUserEdit(
          this.props.userData,
          null,
          FeatureCodes.REPORTS_CONSOLIDATED,
        ) ||
        canUserEdit(
          this.props.userData,
          null,
          FeatureCodes.REPORTS_INTRA_DAY_MANDI,
        ) ||
        canUserEdit(
          this.props.userData,
          null,
          FeatureCodes.REPORTS_PRICE_TREND,
        ) ||
        canUserEdit(
          this.props.userData,
          null,
          FeatureCodes.REPORTS_USER_ADOPTION,
        ) ? (
          <TabPane tab="Report" key="7">
            <Report />
          </TabPane>
        ) : null,

        canUserEdit(this.props.userData, null, FeatureCodes.ADMIN_ACCESS) ||
        canUserEdit(
          this.props.userData,
          null,
          FeatureCodes.ALERTS_PUBLISHING,
        ) ||
        canUserEdit(this.props.userData, null, FeatureCodes.ALERTS_GROUP) ? (
          <TabPane tab="Admin" key="8">
            <AdminTabs />
          </TabPane>
        ) : null,
        canUserEdit(
          this.props.userData,
          null,
          FeatureCodes.MASTER_SCREEN_VIEW,
        ) ? (
          <TabPane tab="Master" key="11">
            <MasterTabs />
          </TabPane>
        ) : null,
        <TabPane tab="  " key="18"></TabPane>,
        canUserEdit(
          this.props.userData,
          null,
          FeatureCodes.WEEKLY_MODEL_EDIT,
        ) ||
        canUserEdit(
          this.props.userData,
          null,
          FeatureCodes.WEEKLY_MODEL_VIEW,
        ) ||
        canUserEdit(
          this.props.userData,
          null,
          FeatureCodes.MONTHLY_MODEL_FORECAST_EDIT,
        ) ||
        canUserEdit(
          this.props.userData,
          null,
          FeatureCodes.MONTHLY_MODEL_FORECAST_VIEW,
        ) ||
        canUserEdit(
          this.props.userData,
          null,
          FeatureCodes.MONTHLY_CONSTRAINTS,
        ) ? (
          <TabPane tab="Forecast" key="9">
            <ForecastTabs />
          </TabPane>
        ) : null,
      ];
    }
  };
  render() {
    const {
      collapseSidemenu,
      history,
      setSummaryVisibility,
      setCurrentArrivalScreen,
      setUserLoggedStatus,
      clickDisable,
    } = this.props;

    /**
     * @function
     * @description Closes the menu
     * @memberof App.MainLayout.MainContent
     */
    const onClose = () => {
      this.setState({ menuVisible: false });
    };

    /**
     * @function
     * @description Opens the menu
     * @memberof App.MainLayout.MainContent
     */
    const openMenu = () => {
      this.setState({ menuVisible: true });
    };

    // Tab extra contents
    /**
     * @component
     * @description Additional components displayed in the tab.
     * @memberof App.MainLayout.MainContent
     */
    const tabExtraContent = (
      <div className="toolbar-extra">
        <Drawer
          placement={"right"}
          closable={true}
          onClose={onClose}
          visible={this.state.menuVisible}
        >
          <MenuItemGroup />
        </Drawer>
        <div className="logout-container">
          {window.location.hostname.includes("qa") && (
            // {window.location.port !== "8080" ?
            <div className="differentation-button-container">
              {
                <Button type="primary" shape="round" size="large">
                  <div style={{ float: "right" }}>
                    <div style={{ marginTop: "-7px" }}>UAT Environment</div>
                  </div>
                </Button>
              }
            </div>
          )}
          <WeatherWidget key={new Date()} />
          <Button onClick={this.handleLogoutButton.bind(this)}>Logout</Button>
        </div>
        <div className="burger-menu" onClick={openMenu}>
          <img src={Burger} alt="" style={{ width: "20px", heigh: "20px" }} />
        </div>
      </div>
    );

    return (
      <Tabs
        className={`main-content ${
          this.state.menuVisible ? "main-content-blur" : ""
        }`}
        defaultActiveKey="1"
        activeKey={this.state.currentTab}
        tabBarExtraContent={tabExtraContent}
        onChange={(value) => {
          if (value === "18") {
            API.get("get-token")
              .then((response) => {
                window.open(
                  `https://astra-extension-dev-f8cceebzcsf9cpck.centralindia-01.azurewebsites.net/?token=${response.data.token}`,
                  "_blank",
                ); // For external links
              })
              .catch((error) => {
                console.log("token", error);
              });
          } else {
            setSummaryVisibility(false);
            this.setState({ currentTab: value });
          }
        }}
      >
        <TabPane
          key="1000"
          disabled
          tab={
            <div
              style={{
                height: "20px",
                width: "50px",
                marginTop: "-20px",
                marginLeft: "-12px",
              }}
            >
              <img
                alt="logo"
                style={{
                  cursor: "auto",
                  width: "42px",
                  height: "42px",
                  marginTop: "-5px",
                  marginLeft: "10px",
                }}
                src={Logo}
              ></img>
            </div>
          }
        />
        {this.renderTabs()}
      </Tabs>
    );
    function callback(key) {}
  }
}

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    collapseSidemenu: () => dispatch(collapseSidemenu()),
    setScreen: (data) => dispatch(setScreen(data)),
    setAccessToken: (token) => dispatch(setAccessToken(token)),
    setRefreshToken: (token) => dispatch(setRefreshToken(token)),
    setScreenName: (screenName) => dispatch(setScreenName(screenName)),
    setSummaryVisibility: (isEnabled) =>
      dispatch(setSummaryVisibility(isEnabled)),
    setCurrentArrivalScreen: (screenName) =>
      dispatch(setCurrentArrivalScreen(screenName)),
    setUserLoggedStatus: (status) => dispatch(setUserLoggedStatus(status)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MainContent),
);
